// extracted by mini-css-extract-plugin
export default {"background":"styles_background__r2hYJ","container":"styles_container__jzGsz"};